import { Turbo } from "@hotwired/turbo-rails";

// App-styled replacement for Turbo's browser confirm(). Every data-turbo-confirm in
// the dashboard routes through one native <dialog> (rendered by
// dashboard/confirm_dialog) instead of the OS box. The triggering form may carry
// data-turbo-confirm-title, data-turbo-confirm-confirm (the accept label), and
// data-turbo-confirm-variant="danger" to shape the dialog.
Turbo.config.forms.confirm = (message, formElement) => {
  const dialog = document.getElementById("confirm-dialog");
  if (!dialog || typeof dialog.showModal !== "function") {
    return Promise.resolve(window.confirm(message));
  }

  const data = formElement?.dataset ?? {};
  dialog.querySelector("#confirm-dialog-title").textContent = data.turboConfirmTitle || "Are you sure?";
  dialog.querySelector("#confirm-dialog-message").textContent = message || "";

  const accept = dialog.querySelector("#confirm-dialog-accept");
  const cancel = dialog.querySelector("#confirm-dialog-cancel");
  accept.textContent = data.turboConfirmConfirm || "Confirm";

  const danger = data.turboConfirmVariant === "danger";
  accept.classList.toggle("bg-coral-strong", danger);
  accept.classList.toggle("bg-cta", !danger);

  // A stale returnValue from a prior open would otherwise let an Escape dismissal
  // read as a confirmation, so clear it before showing.
  dialog.returnValue = "";
  dialog.showModal();

  return new Promise((resolve) => {
    const controller = new AbortController();
    accept.addEventListener("click", () => dialog.close("confirm"), { signal: controller.signal });
    cancel.addEventListener("click", () => dialog.close("cancel"), { signal: controller.signal });
    dialog.addEventListener(
      "close",
      () => {
        controller.abort();
        resolve(dialog.returnValue === "confirm");
      },
      { once: true }
    );
  });
};
